import api from './api'

export const blogService = {
  getAllBlogs: async () => {
    const response = await api.get('/blogs')
    return response.data
  },

  getBlogById: async (id) => {
    const response = await api.get(`/blogs/${id}`)
    return response.data
  },

  createBlog: async (data) => {
    const response = await api.post('/blogs', data)
    return response.data
  },

  updateBlog: async (id, data) => {
    const response = await api.put(`/blogs/${id}`, data)
    return response.data
  },

  archiveBlog: async (id) => {
    const response = await api.put(`/blogs/${id}/archive`)
    return response.data
  },

  restoreBlog: async (id) => {
    const response = await api.put(`/blogs/${id}/restore`)
    return response.data
  },

  uploadImage: async (id, file) => {
    const formData = new FormData()
    formData.append('image', file)
    const response = await api.post(`/blogs/${id}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  }
}

export function getImageUrl(path) {
  // console.log('Resolving image URL for path:', path)
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  const resolvedPath = path.startsWith('/') ? path : `/${path}`
  // console.log('Resolved image URL:', resolvedPath)
  return resolvedPath
}
